import { SET_LEAD_ID } from 'actions';

export function setLeadId(leadId: string) {
  return { leadId, type: SET_LEAD_ID };
}
